import React from 'react'
import { Icon } from 'semantic-ui-react'
import DeleteIcon from '../deleteIcon'
import { useTranslation } from '@hooks/useTranslation'
import { useContext } from 'react'
import { InvoiceToggleContext } from '@commonComponents/accordion/AccordianInvoice'

const ToggleButton = (props) => {
  const {
    id,
    lineNumber,
    onDelete,
    containerStyle = {},
    title,
    titleStyle={marginRight:'7rem'},
    confirmationMsg,
    buttonName,
    wrapButtonWhenInActive=false,
    toggleId,
    markedDeleted,
    sequenceNumber
  } = props

  const {state,dispatch}=useContext(InvoiceToggleContext)
  const isActive = state?.[`${toggleId}`] 

  const translate = useTranslation();
  const deleteHandle = () => {
    if (!window.confirm(`${translate("REMOVE_MSG")} ${confirmationMsg} ` + counter)) return
    onDelete()
  }
  let counter =
    lineNumber < 10 ? `00${lineNumber}` : lineNumber < 99 ? `0${lineNumber}` : lineNumber
  return (
    <div style={{ display: 'flex',flexWrap:(!wrapButtonWhenInActive && !isActive)?'wrap':'nowrap', ...containerStyle }} className='title'>
      <div style={{marginRight:'10px', display:'flex'}}>
        <div
          style={{
            background: '#fff',
            borderRadius: '5px',
            color: '#1765ae',
            display: 'inline-flex',
            fontWeight: 'bolder',
            textAlign: 'center',
            border: '1px solid #1765ae',
            marginBottom: '10px',
            padding: '3px 5px',
            cursor: 'pointer',
            height:'fit-content'
          }}
          onClick={()=>dispatch({type:"TOGGLE_BY_ID",toggleId})}
        >
          <Icon id={id} name={isActive ? `minus circle` : `plus circle`} />
          {buttonName ?<span>{`${translate(buttonName)} ${counter}`}</span>:<span>{counter}</span>}
        </div>
        {sequenceNumber &&
          <div 
            style={{height:'fit-content', borderRadius:'5px', marginLeft:'10px', textWrap:'nowrap' }} 
            className='stepNumber sequenceNumeric'>
            <span>SEQ-{sequenceNumber}</span>
          </div>
        }
        {(isActive && !markedDeleted) && <span style={{ margin:'5px 4px 5px' }}>
          <DeleteIcon id={`delete-${id}`} onClick={deleteHandle} />
        </span>}
      </div>

      {(isActive && markedDeleted) &&
        <span style={{ alignSelf: 'center' }}>
          {markedDeleted && markedDeleted()}
        </span>}
      <div style={{ flexGrow: 1, textAlign: 'center' }}>
        <div style={{ textTransform: 'uppercase', color: 'black' }}>
          <strong style={titleStyle}>{title && title(isActive)}</strong>
        </div>
      </div>
    </div>
  )
}
export default React.memo(ToggleButton)
